// extracted by mini-css-extract-plugin
module.exports = {"groups":"InternalLinkGroups_groups__h3xb4","group":"InternalLinkGroups_group___L8lK","title":"InternalLinkGroups_title__iDAS_","pill":"InternalLinkGroups_pill__MeqoM"};